module.exports = __webpack_public_path__ + "img/climb-wall.5043871e.svg";